var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext, useLayoutEffect, useRef, useState, } from 'react';
import * as ReactDOM from 'react-dom';
import classnames from 'classnames';
import { Positioner } from './Positioner';
import "./dropdownMenu.css";
import { useBEM, PopupsContext } from '../../utils';
export var createPortalRoot = function (rootId, className) {
    var rootElement = document.createElement('div');
    rootElement.id = rootId;
    if (className)
        rootElement.className = className;
    return rootElement;
};
var MENU_DEFAULT_OFFSET = 8;
var _a = useBEM('lk-ui__dd-menu'), menuBlock = _a[0], menuModifier = _a[1];
export var DropdownContext = createContext({});
export var DropdownMenu = function (_a) {
    var _b = _a.verticalOffset, verticalOffset = _b === void 0 ? MENU_DEFAULT_OFFSET : _b, _c = _a.horizontalOffset, horizontalOffset = _c === void 0 ? 0 : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, targetElement = _a.targetElement, className = _a.className, applicationRootElementIDProps = _a.applicationRootElementID, dropdownElementIDProps = _a.dropdownElementID, children = _a.children, onOutsideClick = _a.onOutsideClick, _e = _a.scrollable, scrollable = _e === void 0 ? true : _e, minHeight = _a.minHeight;
    var _f = useContext(DropdownContext), applicationRootElementIDContext = _f.applicationRootElementID, dropdownElementIDContext = _f.dropdownElementID, rootElementDDContext = _f.rootElement;
    var _g = useContext(PopupsContext), applicationElementID = _g.applicationElementID, rootElementContext = _g.rootElement;
    var rootElementID = applicationRootElementIDProps ||
        applicationRootElementIDContext ||
        applicationElementID ||
        'root';
    var dropdownElementID = dropdownElementIDProps ||
        dropdownElementIDContext ||
        'lk-ui__dropdown-root';
    var element = rootElementDDContext || rootElementContext;
    var dropdownMenuRef = useRef(null);
    var _h = useState(), rootElement = _h[0], setRootElement = _h[1];
    useLayoutEffect(function () {
        var mountElement = element || document.getElementById(rootElementID);
        if (!mountElement)
            throw new Error("Application root element with ID \"" + rootElementID + "\" not found");
        var dropdownElement = createPortalRoot(dropdownElementID, className);
        var root = mountElement.appendChild(dropdownElement);
        setRootElement(root);
        return function () {
            mountElement.removeChild(dropdownElement);
        };
    }, [rootElementID, dropdownElementID, className, element]);
    useLayoutEffect(function () {
        var handleOutsideClick = function (event) {
            var targetElement = event === null || event === void 0 ? void 0 : event.target;
            var dropdownElement = dropdownMenuRef === null || dropdownMenuRef === void 0 ? void 0 : dropdownMenuRef.current;
            var isOutsideClick = dropdownElement && !dropdownElement.contains(targetElement);
            if (isOutsideClick) {
                onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick();
            }
        };
        var listenerContainer = rootElement || window;
        listenerContainer === null || listenerContainer === void 0 ? void 0 : listenerContainer.addEventListener('mousedown', handleOutsideClick);
        return function () {
            return listenerContainer === null || listenerContainer === void 0 ? void 0 : listenerContainer.addEventListener('mousedown', handleOutsideClick);
        };
    }, [onOutsideClick]);
    var positionerProps = {
        align: align,
        horizontalOffset: horizontalOffset,
        targetElement: targetElement,
        verticalOffset: verticalOffset,
        scrollable: scrollable,
        minHeight: minHeight,
    };
    var menuClass = classnames(menuBlock, menuModifier("align-" + align));
    if (!rootElement)
        return null;
    return ReactDOM.createPortal(React.createElement(Positioner, __assign({}, positionerProps),
        React.createElement("div", { ref: dropdownMenuRef, className: menuClass }, children)), rootElement);
};
